import * as React from "react";
import { cn } from "@/lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { FieldOption } from "@/config/forms/general";

interface InputSelectProps extends React.InputHTMLAttributes<HTMLInputElement> {
  options: FieldOption[] | undefined;
  selectPlaceholder?: string;
  onSelectChange?: (value: string) => void;
  defaultSelectValue?: string;
  className?: string;
  selectClassName?: string;
}

const InputSelect = React.forwardRef<HTMLInputElement, InputSelectProps>(
  (
    {
      className,
      selectClassName,
      options,
      selectPlaceholder = "Select...",
      onSelectChange,
      defaultSelectValue,
      type = "text",
      ...props
    },
    ref,
  ) => {
    return (
      <div className="flex w-full gap-2 border shadow-sm rounded-md">
        <Input
          type={type}
          className={cn("flex-1 border-none shadow-none", className)}
          ref={ref}
          {...props}
        />
        <Select
          onValueChange={onSelectChange}
          defaultValue={defaultSelectValue}
        >
          <SelectTrigger
            className={cn("w-[140px border-none shadow-none", selectClassName)}
          >
            <SelectValue placeholder={selectPlaceholder} />
          </SelectTrigger>
          <SelectContent>
            {options?.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    );
  },
);

export default InputSelect;
